import { Icon } from '@aibees/shared/components';
import { Stack, Typography } from '@mui/material';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ReportAccordianProps as Props } from './types';

export const ReportAccordian = memo(({ className, title, children }: Props) => {
  const state = useBoolean(true);

  const handelExpand = () => {
    if (state.value) {
      state.onFalse();
    } else state.onTrue();
  };

  return (
    <Styled.Wrapper
      className={classnames('ReportAccordian', className)}
      sx={SX.root}
      expanded={state.value}
    >
      <Styled.CustomSummary
        onClick={handelExpand}
        expandIcon={
          <Icon
            name="arrow-accordion"
            onClick={handelExpand}
            size={12}
            sxx={SX.icon(state.value)}
          />
        }
        sx={SX.summary(state.value)}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography sx={SX.title}>{title}</Typography>
        </Stack>
      </Styled.CustomSummary>
      <Styled.DetailWrapper sx={SX.detail(state.value)}>
        {children}
      </Styled.DetailWrapper>
    </Styled.Wrapper>
  );
});

ReportAccordian.displayName = 'ReportAccordian';
